import { Link } from "react-router-dom";
import { PRODUCTS } from "@/src/constants/constants";
import { useCartContext } from "@/src/context/CartContext";
import { ProductCard } from "@/src/pages/home/(sections)/products/ProductCard";

interface RelatedProductsProps {
    currentId: string;
}

export function RelatedProducts({ currentId }: RelatedProductsProps) {
    const { addToCart } = useCartContext();
    const related = PRODUCTS.filter((p) => p.id !== currentId).slice(0, 3);

    return (
        <section className="max-w-7xl mx-auto px-6 pb-24">
            <div className="border-t border-stone-100 pt-16 mb-12 flex justify-between items-end">
                <h2 className="font-serif text-3xl font-light italic">
                    You may also like
                </h2>
                <Link
                    to="/collection"
                    className="text-xs uppercase tracking-widest border-b border-stone-300 pb-1 hover:border-stone-900 transition-colors"
                >
                    View all
                </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-16">
                {related.map((product, index) => (
                    <ProductCard
                        key={product.id}
                        product={product}
                        index={index}
                        onAddToCart={addToCart}
                    />
                ))}
            </div>
        </section>
    );
}
